<template>
  <encryption-field :field-name="fieldName" :encrypted-value="encryptedValue" :label="label">
    <template #default="{ value }">
      <span v-if="!urls(value).length">{{ value ? '--' : '********' }}</span>
      <el-image
        v-for="url in urls(value)" :key="url" :src="url"
        :preview-src-list="urls(value)" fit="contain" style="width: 50px; margin-right: 5px"
      />
    </template>
  </encryption-field>
</template>

<script>
import EncryptionField from '@/components/EncryptionField/index.vue';
export default {
  name: 'SensitiveImages',
  components: { EncryptionField },
  props: {
    fieldName: { type: String, required: true },
    encryptedValue: { type: String, default: '' },
    label: { type: String, required: true }
  },
  methods: {
    // 隐藏或身份切换后清空插槽值，销毁图片及预览，禁止将密文当作 URL 加载。
    urls(value) { return typeof value === 'string' ? value.split(',').filter(url => /^https?:\/\//i.test(url)) : []; }
  }
};
</script>
